import { createSlice } from "@reduxjs/toolkit";
import { getMonthsAgo } from "helpers/dates";
import { isBlank } from "helpers/strings";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export const DefaultInputFilter = { label: "همه نهاده ها", value: 0 };
export const DefaultConcentrateFilter = { label: "کنسانتره", value: null };

export const DateRadio = {
  LastMonth: "last-month-inputs",
  LastThreeMonths: "last-three-months-inputs",
  CustomDate: "arbitary-time-range",
};

const DefaultDateFilter = {
  from: new DateObject(getMonthsAgo(1))
    .convert(gregorian, gregorian_en)
    .toUTC()
    .format("YYYY-MM-DD"),
  to: new DateObject(new Date())
    .convert(gregorian, gregorian_en)
    .toUTC()
    .format("YYYY-MM-DD"),
};

const INITIAL_STATE = {
  pageOffset: 1,
  fromDate: DefaultDateFilter.from,
  toDate: DefaultDateFilter.to,
  selectedInput: DefaultInputFilter,
  pickedDateFrom: DefaultDateFilter.from,
  pickedDateTo: DefaultDateFilter.to,
  selectedRadio: DateRadio.LastMonth,
  filterQuery: `?start_date=${DefaultDateFilter.from}&end_date=${DefaultDateFilter.to}&all_items=true&`,
  productsFilterQuery: `?start_date=${DefaultDateFilter.from}&end_date=${DefaultDateFilter.to}&all_items=true&`,
  storeFilterQuery: '?all_items=true&'
};

export const filterSlice = createSlice({
  name: "filter",
  initialState: Object.assign({}, INITIAL_STATE),
  reducers: {
    goToPage: (state, data) => {
      state.pageOffset = data.payload;
    },
    pickFromDate: (state, data) => {
      state.pickedDateFrom = data.payload;
      if (state.selectedRadio === DateRadio.CustomDate) {
        state.fromDate = data.payload;
      }
    },
    pickToDate: (state, data) => {
      state.pickedDateTo = data.payload;
      if (state.selectedRadio === DateRadio.CustomDate) {
        state.toDate = data.payload;
      }
    },
    handleInputChange: (state, data) => {
      state.selectedInput = data.payload;
    },
    handleDateRadioChange: (state, data) => {
      const radioId = data.payload;

      state.selectedRadio = radioId;

      let from, to;
      switch (radioId) {
        case DateRadio.LastMonth:
          from = getMonthsAgo(1).toISOString();
          to = new Date().toISOString();
          break;
        case DateRadio.LastThreeMonths:
          from = getMonthsAgo(3).toISOString();
          to = new Date().toISOString();
          break;
        case DateRadio.CustomDate:
          from = state.pickedDateFrom;
          to = state.pickedDateTo;
          break;
        default:
        //stuff
      }

      state.fromDate = from;
      state.toDate = to;
    },
    buildFiltersQuery: (state, _) => {
      let filters = "?all_items=true&";
      let productsFilter = "?all_items=true&";
      let storeFilter = "?all_items=true&";

      if (state.pageOffset > 1) {
        filters += `page=${state.pageOffset}&`;
        productsFilter += `page=${state.pageOffset}&`;
      }

      if (!isBlank(state.fromDate)) {
        const formattedString = new DateObject(new Date(state.fromDate))
          .convert(gregorian, gregorian_en)
          .toUTC()
          .format("YYYY-MM-DD");
        filters += `start_date=${formattedString}&`;
        productsFilter += `start_date=${formattedString}&`;
      }
      if (!isBlank(state.toDate)) {
        const formattedString = new DateObject(new Date(state.toDate))
          .convert(gregorian, gregorian_en)
          .toUTC()
          .format("YYYY-MM-DD");
        filters += `end_date=${formattedString}&`;
      }
      if (state.selectedInput.value > 0) {
        filters += `input_id=${state.selectedInput.value}&`;
        productsFilter += `food_item_id=${state.selectedInput.value}&`;
        storeFilter += `input_id=${state.selectedInput.value}&`;
      }

      state.filterQuery = `${filters}`;
      state.productsFilterQuery = `${productsFilter}`;
      state.storeFilterQuery = `${storeFilter}`;
    },
    resetAllFilters: (state, _) => {
      const from = new DateObject(getMonthsAgo(1))
        .convert(gregorian, gregorian_en)
        .toUTC()
        .format("YYYY-MM-DD");

      const to = new DateObject(new Date())
        .convert(gregorian, gregorian_en)
        .toUTC()
        .format("YYYY-MM-DD");

      state.pageOffset = 1;
      state.fromDate = from;
      state.toDate = to;
      state.selectedInput = DefaultInputFilter;
      state.pickedDateFrom = from;
      state.pickedDateTo = to;
      state.selectedRadio = DateRadio.LastMonth;

      state.filterQuery = `?start_date=${from}&end_date=${to}&all_items=true&`;
      state.productsFilterQuery = `?start_date=${from}&end_date=${to}&all_items=true&`;
      state.storeFilterQuery = '?all_items=true&';
    },
  },
});

export const {
  goToPage,
  handleDateRadioChange,
  pickFromDate,
  pickToDate,
  handleInputChange,
  buildFiltersQuery,
  resetAllFilters,
} = filterSlice.actions;
export default filterSlice.reducer;
